import React, { useState, useEffect } from 'react'
import './inbox.scss';
import axios from 'axios';
import { message, Pagination, Spin } from 'antd';
import nothingImg from '../../../images/nothing.png';
import moment from 'moment'

function Inbox(props) {
  const [receiveLetters, setReceiveLetters] = useState([]);
  const [totalLetters, setTotalLetters] = useState(1);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getReceiveLetters(1);
  }, [])

  const getReceiveLetters = (page) => {
    const { companyName } = sessionStorage;

    setLoading(true);
    axios({
      method: 'post',
      url:"/exchange/receive/receiveList.ajax",
      headers: {'Content-Type': 'application/json'}, // application/x-www-form-urlencoded
      data: {
        page,
        receivedStatus: "1",
        rows: 10,
        companyName
      }
    })
      .then((res) => {
        if (res.status !== 200) return message.error(" 数据获取失败！");
        setReceiveLetters(res.data.data.list);
        setTotalLetters(res.data.data.total);
      }).then(() => {
        setLoading(false);
      }).catch(() => {
        setLoading(false);
      })
  }

  const pageChange = (page, pageSize) => {
    getReceiveLetters(page);
  }

  return (
    <div className="inbox-wrapper">
        <div className="inbox">
            <div className="inbox-header">  收件箱 </div>
            <div className="inbox-body">
                <div className="table-header">
                  <div className="addresser">发件人</div>
                  <div className="addresser-company">发件人所属公司</div>
                  <div className="adatcsatorna">资料摘要</div>
                  <div className="receipt-time">接收时间</div>
                </div>
                <Spin spinning={loading}>
                  <div className="table-body">
                    {
                      receiveLetters.length ? receiveLetters.map((item, index) => {
                        return (
                          <div className="table-line" key={`line${index}`}>
                            <div className="addresser">{item.sender || '---'}</div>
                            <div className="addresser-company">{item.sendCompany || '---'}</div>
                            <div className="adatcsatorna">{item.dataDigest || '---'}</div>
                            <div className="receipt-time">{moment(item.reviewTime).format('YYYY-MM-DD HH:mm:ss')|| '---'}</div>
                          </div>
                        )
                      }) : 
                      <div className="nothing-warpper">
                        <img src={nothingImg} />
                      </div>
                    }
                  </div>
                </Spin>
                
                <div className="table-line-number">
                  <span className="table-line-total">共 {totalLetters} 条</span>
                  {
                    totalLetters ?
                    <Pagination defaultCurrent={1} total={totalLetters} onChange={(page, pageSize) => {pageChange(page, pageSize)}}/> :
                    ''
                  }
                </div>
            </div>
        </div>
    </div>
  );
}

export default Inbox;
